export default __webpack_public_path__ + "static/media/700.84a50dff.png";